import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const Cookies = () => {
  return (
    <LegalPageLayout
      title="No-Cookie Policy"
      intro="This policy clarifies that FluxSpaces operates without cookies or comparable tracking technologies."
      lastUpdated="5 June 2024"
    >
      <section className="flux-legal-section">
        <h2>No Cookies in Use</h2>
        <p>
          We currently do not use cookies, tracking pixels, or similar recognition
          technologies on fluxspaces.app. You can browse the site without a cookie banner,
          because we do not store personal data on your device for analytics, marketing, or
          personalisation purposes.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Technically Necessary Storage</h2>
        <p>
          We also refrain from using technically necessary cookies or local storage at this
          time. If that changes, we will provide transparent information about the purpose,
          legal basis, duration, and any third-party involvement before placing such
          storage on your device.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Updates</h2>
        <p>
          We update this statement whenever we introduce features that require storing
          information on your device. Please revisit this page regularly to stay informed.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>Contact</h2>
        <p>
          If you have questions about our data practices or our no-cookie approach, contact
          us at <a href="mailto:ronny@fluxspaces.app">ronny@fluxspaces.app</a>.
        </p>
      </section>
    </LegalPageLayout>
  );
};

export default Cookies;
